module.exports = "/_next/static/images/shivam-15a98d65ab3ca71817a05705bbddd538.png";